import React, { useState, useEffect } from "react";
import strings from "./Utils/strings";
import { Route, Routes } from "react-router-dom";
import Component from "./Components";
import "./App.css";
import authService from "./Services/authService";

function Navigation() {
  const [doRefresh, setDoRefresh] = useState(false);
  const [isDoctorLogin, setIsDoctorLogin] = useState(false);

   useEffect(() => {
      setIsDoctorLogin(authService.getIsDoctorLogin() === "true");
      console.log(authService.getIsDoctorLogin() === "true")
    }, []);
  
  return (
    <Routes>
      <Route element={<Component.CommonLayout />}>
        <Route exact path={strings.navigation.welcome} element={<Component.WelcomeScreen />} />
      </Route>
      <Route element={<Component.ValidateSession />}>
        <Route element={<Component.HomeLayout refresh={doRefresh} />}>
          <Route exact path={strings.navigation.dashboard} element={<Component.HospitalDashboard />} />
          <Route exact path={strings.navigation.waivedOffAppointments} element={<Component.WaivedOffAppointments />} />
          <Route exact path={strings.navigation.manageDoctor} element={<Component.ManageDoctor />} />
          <Route exact path={strings.navigation.doctorProfileView} element={<Component.DoctorProfileView />} />
          <Route exact path={strings.navigation.viewClinicProfile} element={<Component.ViewClinicProfile />} />
          <Route exact path={strings.navigation.appointmentApprove} element={<Component.ApprovedAppointment />} />
          {!isDoctorLogin && <Route exact path={strings.navigation.appointmentRequest} element={<Component.RequestAppointment />} />}
          <Route exact path={strings.navigation.report} element={<Component.ClinicReport />} />
        </Route>
        <Route exact path={strings.navigation.zoom} element={<Component.NewZoom />} />
        {/* <Route exact path={strings.navigation.zoomTest} element={<Component.NewZoomA />} /> */}
      </Route>
    </Routes>
  );
}

export default Navigation;
